module.exports = __webpack_public_path__ + "media/images/winner--right-b8dbd6d37b1889a8387d1c997db95a6e.png";